export default __webpack_public_path__ + "static/media/Link_gd.8dcd2972.svg";